import { Controller } from "@hotwired/stimulus"

// Highlight: on connect, scroll the element into view and briefly flash it
// yellow so a freshly-added item is easy to spot. Used for new blog rows.
//
//   <div data-controller="highlight">…</div>
export default class extends Controller {
  connect() {
    this.element.scrollIntoView({ behavior: "smooth", block: "center" })

    // Drive the flash with inline styles: an inline background-color outranks
    // the element's bg-white class, so we avoid Tailwind's class-ordering
    // pitfall. Jump to the tint with NO transition, force a reflow to commit it
    // as the start state, THEN enable the transition and clear the tint so it
    // animates back to the bg-white from the class. Enabling the transition
    // before painting the tint would just animate into-and-out-of it, leaving
    // the background visually unchanged.
    this.element.style.backgroundColor = "var(--color-brand)" // brand tint
    void this.element.offsetHeight // force reflow — commit yellow instantly
    this.element.style.transition = "background-color 1s ease"
    this.element.style.backgroundColor = ""

    this.element.addEventListener(
      "transitionend",
      () => { this.element.style.transition = "" },
      { once: true }
    )
  }
}
